import { render, staticRenderFns } from "./UpdateWebsiteActionStatusDialog.vue?vue&type=template&id=2934db9a&"
import script from "./UpdateWebsiteActionStatusDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateWebsiteActionStatusDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports